// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__FbVfj","OrderButton":"BuildControls_OrderButton__S4nrM","enable":"BuildControls_enable__1rJGl"};